var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vks-canvas" }, [
    _c(
      "div",
      { staticClass: "vks-canvas-viewport", style: _vm.viewportStyle },
      [
        _vm.welcomeOpen
          ? _c("GP2BrowserWelcomePanel", {
              attrs: {
                phenotypes: _vm.phenotypes,
                utils: _vm.utils,
                "initial-values": _vm.welcomeInitialValues,
                "project-id": _vm.projectId,
                "bio-index-host": _vm.geneLookupBioIndexHost,
                "welcome-title": _vm.welcomeTitle,
              },
              on: {
                "start-search": function ($event) {
                  return _vm.$emit("start-search", $event)
                },
                "import-session": function ($event) {
                  return _vm.$emit("import-session")
                },
              },
            })
          : _vm._e(),
        _vm.canvasActive
          ? _c(
              "div",
              { staticClass: "vks-canvas-tracks" },
              [
                _vm._l(_vm.canvasTrackSections, function (section) {
                  return [
                    section.id === "associations"
                      ? _c("GP2BrowserAssociationsPlot", {
                          key: section.id,
                          attrs: {
                            rows: _vm.associationPlotRows,
                            "selected-ancestries":
                              _vm.associationsState.selectedAncestries || [],
                            "selected-phenotypes":
                              _vm.associationsState.selectedPhenotypes || [],
                            loading: _vm.associationsState.loading,
                            "hide-loading-status": _vm.regionLoadProgressActive,
                            "ld-loading": _vm.associationsState.ldLoading,
                            "ld-error": _vm.associationsState.ldError,
                            error: _vm.associationsState.error,
                            "search-session": _vm.searchSession,
                            "region-zoom": _vm.regionZoom,
                            "region-shift-bp": _vm.regionShiftBp,
                            "region-view-area": _vm.regionViewArea,
                            "view-region": _vm.viewRegion,
                            "active-search-region": _vm.activeSearchRegion,
                            "viewing-center-bp": _vm.viewingCenterBp,
                            "viewing-region-half-width-bp":
                              _vm.viewingRegionHalfWidthBp,
                            "genes-state": _vm.genesState,
                            "qtl-state": _vm.qtlState,
                            "plot-overlays-state": _vm.plotOverlaysState,
                            "plot-markers": _vm.plotMarkers,
                            "credible-sets-state": _vm.credibleSetsState,
                            "credible-set-colors": _vm.credibleSetColors,
                            "credible-set-pill-colors":
                              _vm.credibleSetPillColors,
                            "global-enrichment-state":
                              _vm.globalEnrichmentState,
                            "v2g-state": _vm.v2gState,
                            "s2g-state": _vm.s2gState,
                            "visible-section-ids": _vm.visibleSectionIds,
                            "workspace-mapping-filter":
                              _vm.workspaceMappingFilter,
                            utils: _vm.utils,
                            "tissue-regions-host": _vm.tissueRegionsHost,
                            "project-id": _vm.projectId,
                          },
                          on: {
                            "update:regionShiftBp": function ($event) {
                              return _vm.$emit("update:regionShiftBp", $event)
                            },
                            "update:regionViewArea": function ($event) {
                              return _vm.$emit("update:regionViewArea", $event)
                            },
                            "update:viewingCenterBp": function ($event) {
                              return _vm.$emit("update:viewingCenterBp", $event)
                            },
                            "commit-viewing-region": function ($event) {
                              return _vm.$emit("commit-viewing-region")
                            },
                            "pan-end": function ($event) {
                              return _vm.$emit("pan-end")
                            },
                            "toggle-position-marker": function ($event) {
                              return _vm.$emit("toggle-position-marker", $event)
                            },
                            "toggle-star-variant": function ($event) {
                              return _vm.$emit("toggle-star-variant", $event)
                            },
                            "toggle-qtl-star-variant": function ($event) {
                              return _vm.$emit(
                                "toggle-qtl-star-variant",
                                $event
                              )
                            },
                            "set-reference-variant": function ($event) {
                              return _vm.$emit("set-reference-variant", $event)
                            },
                            "update:geSelectedBiosamples": function ($event) {
                              return _vm.$emit(
                                "update:geSelectedBiosamples",
                                $event
                              )
                            },
                            "update:geActiveAnnotation": function ($event) {
                              return _vm.$emit(
                                "update:geActiveAnnotation",
                                $event
                              )
                            },
                            "update:geSelectedTissues": function ($event) {
                              return _vm.$emit(
                                "update:geSelectedTissues",
                                $event
                              )
                            },
                            "update:geSelectedAnnotations": function ($event) {
                              return _vm.$emit(
                                "update:geSelectedAnnotations",
                                $event
                              )
                            },
                            "select-ge-plot-tissue": function ($event) {
                              return _vm.$emit("select-ge-plot-tissue", $event)
                            },
                            "update:geBiosampleFilterOptions": function (
                              $event
                            ) {
                              return _vm.$emit(
                                "update:geBiosampleFilterOptions",
                                $event
                              )
                            },
                            "update:geBiosampleTissueRegions": function (
                              $event
                            ) {
                              return _vm.$emit(
                                "update:geBiosampleTissueRegions",
                                $event
                              )
                            },
                            "update:geBiosampleLoading": function ($event) {
                              return _vm.$emit(
                                "update:geBiosampleLoading",
                                $event
                              )
                            },
                            "update:v2gSelectedLinks": function ($event) {
                              return _vm.$emit(
                                "update:v2gSelectedLinks",
                                $event
                              )
                            },
                            "update:s2gSelectedLinks": function ($event) {
                              return _vm.$emit(
                                "update:s2gSelectedLinks",
                                $event
                              )
                            },
                          },
                        })
                      : _c("VariantSifterTrackStrip", {
                          key: section.id + "-strip",
                          attrs: { section: section },
                        }),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
        _c("VariantSifterDataTableModal", {
          attrs: {
            open: _vm.dataTableOpen,
            "association-rows": _vm.associationTableRows,
            "search-session": _vm.searchSession,
            "selected-phenotypes":
              _vm.associationsState.selectedPhenotypes || [],
            "project-id": _vm.projectId,
            "credible-sets-state": _vm.credibleSetsState,
            "global-enrichment-state": _vm.globalEnrichmentState,
            "v2g-state": _vm.v2gState,
            "s2g-state": _vm.s2gState,
            "mapping-state": _vm.mappingState,
            "workspace-mapping-filter": _vm.workspaceMappingFilter,
            utils: _vm.utils,
            "starred-variant-ids": _vm.starredVariantIds,
          },
          on: {
            close: function ($event) {
              return _vm.$emit("close-data-table")
            },
            "toggle-star-variant": function ($event) {
              return _vm.$emit("toggle-star-variant", $event)
            },
            "update:mappingState": function ($event) {
              return _vm.$emit("update:mappingState", $event)
            },
            "update:workspaceFilterActive": function ($event) {
              return _vm.$emit("update:workspaceFilterActive", $event)
            },
            "remove-mapping-category": function ($event) {
              return _vm.$emit("remove-mapping-category", $event)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }